import { MDBAlert, MDBChip, MDBCol, MDBInput, MDBRow, MDBScrollspy, MDBScrollspyLink, MDBCheckbox } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { editHuntGroup, getMisc } from "../../../apiclients/streamsapi_bridge";

import {
  MDBBtn, MDBIcon
} from "mdb-react-ui-kit";
import TelephoneNumbers from '../../TelephoneNumbers';
import AudioPlayer from '../../mediaplayers/AudioPlayer';
import { useFormContext } from 'react-hook-form';

export default function HGeneralSettings({ selectedPhoneNum, hgcode, groupname, setMessage, setHgUpdated, greetingsInfo, setIsloading }) {
  const { t, i18n } = useTranslation();
  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);
  //const [hgcode, sethgcode] = useState('');
  const [autoext, setAutoext] = useState(false);
  const [checkAvailbility, setCheckAvailbility] = useState("");
  const [checkAvailbilityTxt, setCheckAvailbilityTxt] = useState("");
  const [extCheckFlag, setextCheckFlag] = useState(0);
  const navigate = useNavigate();
  const [updatePHNum, setUpdatePHNum] = useState([]);
  const [removePHNum, setRemovePHNum] = useState([]);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [selectedPHnums, setSelectedPHnums] = useState([]);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
  const [freePhoneFlag, setfreePhoneFlag] = useState(true);
  const [numberFlag, setnumberFlag] = useState(true);
  const [sourceNumber, setSourceNumber] = useState([]);
  const { pre_announce: preAnnounce } = greetingsInfo ?? {};
  const [extensionFlag, setExtensionFlag] = useState(true);
  const [defaultExtension, setDefaultExtension] = useState(0);
  const [locationList, setLocationList] = useState([]);
  const [billingList, setBillingList] = useState([]);
  const [showPreAnno, setShowPreAnno] = useState(false);
  const [greetingMode, setGreetingMode] = useState(0);
  const [audioData, setAudioData] = useState('');
  const [dbPhoneNumbers, setdbPhoneNumbers] = useState([]);
  const { register, formState: { errors }, setValue, getValues, watch, setError, clearErrors } = useFormContext();


  useEffect(() => {
    if (preAnnounce?.greeting_id) {
      setShowPreAnno(true);
    } else {
      setShowPreAnno(false);
      setAudioData('');
    }

  }, [preAnnounce]);

  useEffect(() => {
    if (extensionFlag && getValues("extension") != 0) {
      setDefaultExtension(getValues("extension"));
      setExtensionFlag(false);
    }
  }, [extensionFlag, getValues("extension")]);

  useEffect(() => {
    if (selectedPhoneNum.length > 0) {

      setSelectedPHnums(selectedPhoneNum);
      setdbPhoneNumbers(selectedPhoneNum);

    }

  }, [selectedPhoneNum]);



  useEffect(() => {
    if (freePhoneFlag) {
      getFreePhoneNumbers();
      setfreePhoneFlag(false);
    }
  }, [freePhoneFlag]);

  useEffect(() => {
    if (numberFlag) {
      getAvailableNumbers();
      setnumberFlag(false);
    }
  }, [numberFlag]);

  async function getAvailableNumbers() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["free_dids"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + basicInfo);
    // alert(JSON.stringify(basicInfo.misc.free_dids))
    setSourceNumber(basicInfo.misc.free_dids);
  }

  async function getFreePhoneNumbers() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["all_locations", "billinggroups"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + basicInfo);
    // alert(JSON.stringify(basicInfo.misc.free_dids))
    setLocationList(basicInfo.misc.all_locations);
    setBillingList(basicInfo.misc.billinggroups);
  }

  useEffect(() => {
    if (updatePHNum.length > 0 && updateNumbersExecuted) {
      addPhoneNumbers("adddids");
      setUpdateNumbersExecuted(false);
    }
  }, [updatePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (updatePHNum.length > 0 && deleteNumberFlag) {
      addPhoneNumbers("removedids");
      setDeleteNumberFlag(false);
    }
  }, [updatePHNum, deleteNumberFlag]);

  async function addPhoneNumbers(fieldName) {
    setIsloading(true);
    let update = {
      reqid: 9,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      code: hgcode,
      [fieldName]: updatePHNum,
    };

    console.log(JSON.stringify(update));
    //alert(JSON.stringify(update));
    let saverep = await editHuntGroup(update);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    //alert("response JSON ::: of update number ::::: " + JSON.stringify(saverepeMsg));

    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fieldName === "adddids") {
        setSelectedPHnums((prev) => [...prev, ...updatePHNum]);
        setdbPhoneNumbers((prev) => [...prev, ...updatePHNum]);
        setMessage(`Telephone Number ${updatePHNum} added successfully.`); // success pop up message.
        setHgUpdated(true);

      } else {
        const updateAddPHNum = selectedPHnums.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSelectedPHnums(updateAddPHNum);
        setdbPhoneNumbers(updateAddPHNum);
        setMessage(`Telephone Number ${updatePHNum} removed successfully.`); // success pop up message.
        setHgUpdated(true);

      }
      setnumberFlag(true);
    } else {
      if (fieldName === "removedids") {
        const modifynum = selectedPHnums.filter((num) => !updatePHNum.includes(num));
        setSelectedPHnums([...modifynum, ...updatePHNum]);
        setdbPhoneNumbers([...modifynum, ...updatePHNum]);
      }
    }
    setIsloading(false);
  }

  async function checkAvailability(e) {
    e.preventDefault();
    e.stopPropagation();
    setextCheckFlag(1);
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: parseInt(e.target.value) }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (tdata.check_ext) {
      setCheckAvailbility(true);
      setError("extension", { message: "Extension is available" });
    } else {
      setCheckAvailbility(false);
      setError("extension", { message: "Extension is not available" });
    }
    console.log(tdata);
  }

  return (
    <>

      <div className="general-settings" id="general">
        {t("general")}
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("Name")}</div>
        <div className="d-flex w-30">
          <div className="phoneselect w-100">
            <input
              maxLength={20}
              className='form-control'
              {...register('name', {
                required: "Name is required",
              })}
            />
            {errors.name && (
              <p className="text-danger">{errors.name.message}</p>
            )}
          </div>
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">
          {t("extension")}
        </div>

        <div className='w-30'>
          <MDBInput
            type="text" name='extension'
            className="w-100"
            maxLength={5}
            {...register("extension", {
              setValueAs: (value) => Number(value),
              required: "Extension is required",
              minLength: {
                value: 3,
                message: 'Extension must be at least 3 characters',
              },
              maxLength: {
                value: 5,
                message: 'Extension must not exceed 5 characters',
              },
            })}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            onChange={(e) => {
              if (e.target.value !== "") {
                if (
                  e.target.value.length >= 3 &&
                  e.target.value.length <= 5
                ) {
                  if (
                    parseInt(defaultExtension) === parseInt(e.target.value)
                  ) {
                    clearErrors("extension");
                  } else {
                    checkAvailability(e);
                  }
                } else {
                  setCheckAvailbility(false);
                  clearErrors("extension");
                }
                setValue("extension", parseInt(e.target.value), {
                  shouldDirty: true,
                });
              } else {
                setValue("extension", "", {
                  shouldDirty: true,
                });
                clearErrors("extension");
                setCheckAvailbility(false);
              }
            }}
          />
          {errors.extension && (
            <>
              {!checkAvailbility && (
                <>
                  <p className="text-danger">{errors.extension.message}</p>
                </>
              )}

              {checkAvailbility && (
                <p style={{ color: "Green" }} className="clr-red">
                  {errors.extension.message}
                </p>
              )}
            </>
          )}


        </div>
      </div>
      {/* <div className="add-numbermain py-2">
                  <div className="tel-numbers">
                    {t("telephone_Numbers")}
                  </div>
                  <MDBBtn
                    className="m-2"
                    onClick={(e) => {
                      e.preventDefault(); // Prevent the form submission
                      toggleShow12(); // Open the modal
                    }}
                  >
                    <MDBIcon fas icon="plus" size="sm" />{t("add_Numbers")}
                  </MDBBtn>
                </div>
                <div className="chips chips-placeholder">
                  {selectedPHnums &&
                    selectedPHnums.length > 0 &&
                    selectedPHnums.map((phone) => (
                      <MDBChip
                        className="m-chip d-inline py-2 px-3"
                        label="Example label"
                        onDelete={handleDelete}
                        key={phone}
                        closeIcon
                        size="sm"
                      >
                        {phone}
                      </MDBChip>
                    ))}
                </div> */}

      <TelephoneNumbers
        savedPhoneNumbers={selectedPHnums}
        setSavedPhoneNumbers={setSelectedPHnums}
        setSuccessMessage={setMessage}
        uniqueid={hgcode}
        setUpdatePHNum={setUpdatePHNum}
        setUpdateNumbersExecuted={setUpdateNumbersExecuted}
        sourceNumber={sourceNumber}
        setDeleteNumberFlag={setDeleteNumberFlag}
        dbPhoneNumbers={dbPhoneNumbers}
      />
      <div className="add-numbermain">
        <div className="tel-numbers">
          {t("location")}
        </div>
        <div className="phoneselect w-30">
          <select
            className="form-control form-select"
            name="San Jose"
            value={parseInt(watch("loc_id"))}
            onChange={(e) =>
              setValue("loc_id", parseInt(e.target.value), {
                shouldDirty: true,
              })
            }

          // value = {alert(getValues("loc_id"))}
          // {...register("loc_id", { setValueAs: (value) => Number(value) })}
          >
            {locationList && locationList.map(loc => (
              <option value={loc.loc_id}>{loc.loc_name}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">
          {t("billing_Group")}
        </div>
        <div className="phoneselect w-30">
          <select
            className="form-control form-select selectname"
            name="Default"

            value={parseInt(watch("billing_grp"))}
            onChange={(e) =>
              setValue("billing_grp", parseInt(e.target.value), {
                shouldDirty: true,
              })
            }
          // {...register("billing_grp", { setValueAs: (value) => Number(value) })}
          >
            {billingList ? (
              billingList.map((billgrp) => (
                <option key={billgrp.groupid} value={billgrp.groupid}>
                  {billgrp.groupname}
                </option>
              ))
            ) : (
              <option value="">Loading...</option>
            )}
          </select>
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">
          {/* {t("hunt-pre-announcment")} */}
          Enable a Pre Announcement Greeting
          <br />
        </div>
        <div className="d-flex">
          <div className="phoneselect">
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" type="checkbox"
                  checked={showPreAnno}
                  onChange={(e) => {
                    setShowPreAnno(!showPreAnno);
                    if ((preAnnounce?.greeting_id && !showPreAnno == false) || ((greetingMode == 1 || greetingMode == 2) && !showPreAnno == false)) {
                      setValue("enable_pre_anno", false, {
                        shouldDirty: true,
                      });
                    } else {
                      setValue("enable_pre_anno", true, {
                        shouldDirty: true,
                      });
                    }

                  }}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {showPreAnno && (
        <div className="add-numbermain add-numbermain-small align-items-start">
          <div>
            <div className="tel-numbers">
            </div>
          </div>
          {hgcode && hgcode !== '' && (<AudioPlayer
            uniqueId={hgcode}
            greetingType={preAnnounce?.greeting_type ?? 5}
            greetingId={preAnnounce?.greeting_id ?? 0}
            fileName={preAnnounce?.filename ?? ''}
            title={t("hunt-pre-announcment")}
            greetingMode={preAnnounce?.filename ?? '' !== '' ? 1 : 2}
            greetingTitle = {preAnnounce?.display ?? ""}
            setGreetingMode={setGreetingMode}
            audioData={audioData}
            setAudioData={setAudioData}
            huntFlag={true}
            greetingObject = {preAnnounce ?? null}
          />)
          }
        </div>
      )}

      {/* <div className="add-numbermain">
        <div className="tel-numbers">
          {t("record_Calls")}
          <br />
          <span className="phrecording text-secondary">
            {t("record_Calls_txt")}
          </span>
        </div>
        <div className="d-flex">
          <div className="phoneselect">
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" type="checkbox"
                  {...register("rec_calls")}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </div> */}

    </>
  );
};